import React from 'react';
import { inject, observer } from 'mobx-react';
import Page from 'app/components/page/Page';
import KentikAiSettings from 'app/views/settings/ai/KentikAiSettings';
import { getKentikAiSettingsTabConfigs } from 'app/views/settings/ai/kentikAiSettingsTabs';
import KaizenSidebarLayout from './KaizenSidebarLayout';

const SETTINGS_TITLE = 'Kentik AI Settings';

// Kentik AI settings rendered inside the AI Advisor, navigated via the AI Advisor sidebar
const KaizenSettings = ({ $auth, $kaizen, match }) => {
  const activeTab = getKentikAiSettingsTabConfigs($auth).find((tab) => tab.id === match.params.tab);
  const pageProps = activeTab
    ? { title: activeTab.title, parentLinks: [{ link: $kaizen.settingsBaseUrl, label: SETTINGS_TITLE }] }
    : { title: SETTINGS_TITLE };

  return (
    <Page {...pageProps} pt={0} pb={0} px={0} overflow="hidden">
      <KaizenSidebarLayout>
        <KentikAiSettings embedded baseUrl={$kaizen.settingsBaseUrl} match={match} />
      </KaizenSidebarLayout>
    </Page>
  );
};

export default inject('$auth', '$kaizen')(observer(KaizenSettings));
